var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "wheel-bet",
      class: {
        "is-own": _vm.bet.isOwn,
        "is-animated": _vm.bet.isAnimated,
        "is-won": _vm.isWon,
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "wheel-bet__avatar link picture",
          class: _vm.getPictureColorClass(_vm.bet.user.nicknameColor),
          attrs: { "aria-label": "个人下注信息" },
        },
        [
          _c("img", {
            staticClass: "image",
            attrs: {
              loading: "lazy",
              src: _vm.getAvatarUrl(_vm.bet.user),
              alt: _vm.bet.user.nickname,
              fetchpriority: "low",
            },
          }),
        ]
      ),
      _c(
        "div",
        { staticClass: "wheel-bet__content" },
        [
          _c("div", { staticClass: "wheel-bet__bank currency_USD" }, [
            _vm._v(" " + _vm._s(_vm.formatCurrency(_vm.bet.itemsTotal)) + " "),
          ]),
          _vm.bet.isOwn
            ? [
                !_vm.streamerMode
                  ? _c("div", { staticClass: "wheel-bet__own" }, [
                      _vm._v("自己"),
                    ])
                  : _c("div", { staticClass: "wheel-bet__own" }, [
                      _vm._v("您的积分"),
                    ]),
              ]
            : [
                _c(
                  "div",
                  {
                    staticClass: "wheel-bet__nickname nickname link",
                    attrs: { "aria-label": "个人下注信息" },
                  },
                  [_vm._v(" " + _vm._s(_vm.bet.user.nickname) + " ")]
                ),
              ],
        ],
        2
      ),
      _c("div", { staticClass: "wheel-bet__won-background" }),
      _vm.bet.winItem
        ? _c(
            "div",
            {
              staticClass: "wheel-bet__won-item item",
              class:
                "item_quality-" +
                _vm.getItemColor(_vm.bet.winItem.extra, _vm.bet.winItem.appId),
              attrs: { title: _vm.isWon ? _vm.bet.winItem.marketName : "" },
            },
            [
              _c("img", {
                staticClass: "image",
                attrs: {
                  loading: "lazy",
                  src: _vm.getItemImageUrl(_vm.bet.winItem.id, "small"),
                  alt: _vm.bet.winItem.marketName,
                  fetchpriority: "low",
                },
              }),
              _c("div", { staticClass: "item__price" }, [
                _vm._v(
                  " " + _vm._s(_vm.formatCurrency(_vm.bet.totalWonUsd)) + " "
                ),
              ]),
            ]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }